import React from 'react';
import { Header, Grid, Checkbox, Label } from 'semantic-ui-react';




class UserRights extends React.Component {
    constructor(props) {
        super(props);
        // console.log("Rights"+this.props);
    }
    componentDidMount() {

    }
    shouldComponentUpdate(nextProps, nextState) {
        // if(this.props.rightsObj!=nextProps.rightsObj){

        if (nextProps.renderstate === false)
            return false; else return true;

    }
    componentDidUpdate(prevProps) {
        // console.log(this.props);
    }
    RightsSubHeader = (_index, _obj) => {
        return (
            <>
                <div ></div>
                <Header as="h4" dividing className="js-title" key={_index}>
                    {_obj.Category}
                </Header>
            </>
        )
    }

    RightsHeader = (_index) => {
        return (
            <Grid.Row className="header" key={_index}>
                <Grid.Column width={1}>   </Grid.Column>
                <Grid.Column width={4}>  Permissions </Grid.Column>
                <Grid.Column width={4}>   Group Name   </Grid.Column>
                <Grid.Column width={8}>    Description    </Grid.Column>
            </Grid.Row>
        )
    }
    PermissionData = (subindex, _obj, _mainindex) => {
        return (
            <Grid.Row className="user_right_data" key={subindex}>
                <Grid.Column width={1}> <Checkbox onChange={(e, { checked }) => { e.target.className = e.target.className === "edited" ? '' : 'edited'; this.props.change(e, _mainindex, _obj.ModuleID) }} checked={_obj.Access === "Y" ? true : false} disabled={_obj.Disabled} /> </Grid.Column>
                <Grid.Column width={4}> {_obj.Permission} </Grid.Column>
                <Grid.Column width={4}>   <Label.Group size='medium'>
                    {_obj.Grouplist.map(x => (
                        (x.GroupShow) ? <Label className="primary">{x.Group_Name}</Label> : ""))}
                </Label.Group> </Grid.Column>
                <Grid.Column width={8}>  {_obj.Description} </Grid.Column>
            </Grid.Row>
        )
    }
    RightsData = (_index, _obj) => {
        return (
            <>
                {this.RightsSubHeader(_index, _obj[0])}
                <Grid columns='equal' inverted className="normal-header" key={_index}>
                    {this.RightsHeader(_index)}

                    {_obj.map((x, i) => {
                        return (x.ShowRights === true) ? this.PermissionData(i, x, _index) : ""
                        //return <PermissionData keys={i} dataValue={x} index={_index}></PermissionData>
                    }, this)}
                </Grid>
            </>
        )
    }


    render() {
        return (
            <>
                <Header as="h2" dividing>
                    User Rights
            </Header>

                {(this.props.rightsObj) ? this.props.rightsObj.map((_arrobj, _index) => {
                    return (_arrobj[0].ShowModule === true) ? this.RightsData(_index, _arrobj) : ""
                    //return this.builddummy();
                }, this) : ""}


            </>
        )
    }
};
export default UserRights